import React               from "react";
import {Grid, makeStyles}                 from '@material-ui/core';

const useStyles = makeStyles(theme =>({
  questionContainer:{
    width: "100%",
    height:"100%",
  },
  reading: {
    width: "80%",
    margin:"10px 0 10px 0 ",
    font: '22px lato',
    letterSpacing: '0.21px',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",

    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",
 
    }, 
  },
  table: {
    width: "100%",
    font: '22px lato',
    border: '1px solid black',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",
 
    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",

    }, 
  },
  tdTable: {
    padding: "0 1%",
    border: '1px solid black',
    textAlign: 'center'
  },
  imgStyle: {
    alignItems: "center",
    width:'100%',
    height:'100%',
    // [theme.breakpoints.down(1400)]:{
    //   width:'85%px',
    //   height:'85%px',
    // },
  },
}));

const QuestionTable = (props) => {
  const classes = useStyles()
 

  return(
    <Grid container className={classes.questionContainer}>
      <p
        className={classes.reading}
      >
        3. ¿Qué función tienen los subtítulos en el texto?
      </p>
      <br/>
      <table className={classes.table}>
        <thead>
          <th style={{ width: "50%", border: '1px solid black',}}>Primer subtítulo</th>
          <th style={{width: "50%", border: '1px solid black',}}>Segundo subtítulo</th>
        </thead>
        <tbody>
          <tr>
            <td className={classes.tdTable}>
              <p>
                A 
              </p>
              <p>
                Presentar información sobre cómo y cuándo surgió el lenguaje.
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                C 
              </p>
              <p>
                Describir las  teorías  que  existen, pues   es   imposible   decirlo   con certeza.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p>
                B 
              </p>
              <p>
                Exponer porqué   se   dice   que África es cuna de la humanidad.
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                D 
              </p>
              <p>
                Mencionar cuáles fueron las primeras palabras de los homínidos.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  )
}

export default QuestionTable;
